import React from 'react';
export function RegistrationForm() {
  return <div className="bg-[#2f5f98] bg-opacity-95 rounded-lg shadow-xl overflow-hidden" data-id="element-412">
      <div className="p-8" data-id="element-413">
        {/* Registration Closed Header */}
        <div className="text-center mb-6" data-id="element-414">
          <div className="inline-block bg-red-500 bg-opacity-20 border-2 border-red-400 px-6 py-3 rounded-lg mb-4" data-id="element-415">
            <h2 className="text-2xl font-bold text-white" data-id="element-416">
              Registration Closed
            </h2>
          </div>
        </div>

        {/* Newsletter Signup Section */}
        <div className="text-center mb-6" data-id="element-417">
          <h3 className="text-2xl font-bold text-white mb-3" data-id="element-418">
            Get notified about a new edition
          </h3>
          <p className="text-white text-opacity-90 mb-6" data-id="element-419">
            Join our newsletter to stay updated on future events
          </p>
        </div>

        {/* Embedded Newsletter Form */}
        <div className="flex justify-center" data-id="element-420">
          <div className="bg-white py-2.5 rounded-lg" style={{
          border: '1px solid #EEE'
        }} data-id="element-421">
            <iframe src="https://www.productcompass.pm/embed" width="480" height="150" style={{
            border: 'none',
            background: 'white',
            maxWidth: '100%',
            display: 'block'
          }} frameBorder="0" scrolling="no" title="Newsletter Signup" data-id="element-422"></iframe>
          </div>
        </div>
      </div>
    </div>;
}